<template>
  <v-container fluid>
    <v-row>
      <v-col sm="4" md="2" xl="1">
        <v-menu
          v-model="datePickerMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              :label="$t('Date')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
            <v-switch v-model="byPrimaryAddress" :label="$t('By primary address')"></v-switch>
          </template>
          <v-date-picker
            :max="maxDate"
            :min="minDate"
            v-model="date"
            no-title
            @input="datePickerMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" md="4">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" :label="$t('Search')" single-line></v-text-field>
      </v-col>
      <v-col cols="auto" class="d-flex align-right">
        <v-btn @click="exportData">{{$t('Download Excel')}}</v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :expanded.sync="expandedArray"
          show-expand
          :headers="headers"
          :items="items"
          :items-per-page="-1"
          :search="search"
          item-key="place"
          :options.sync="gridOptions"
          @item-expanded="expanded"
        >

          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length">
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="detailSearch"
                      prepend-inner-icon="mdi-magnify"
                      :label="$t('Search')"
                      single-line
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table
                      :headers="detailHeaders"
                      :items-per-page="5"
                      :items="detailItems"
                      :search="detailSearch"
                      item-key="place"
                      :options.sync="detailGridOptions"
                    ></v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment-mini";
import api from "../services/ApiService";
import { mapState } from "vuex";
import { getDates } from "../helpers/dateFormat";
import { translateLabel } from "../helpers/dataTranslations";

export default {
  name: "AreaDashboard",

  data() {
    return {
      expandedArray: [],
      date: undefined,
      dateFormatted: "",
      datePickerMenu: false,
      search: "",
      detailSearch: "",
      headers: [],
      detailHeaders: [],
      statuses: [],
      items: [],
      detailItems: [],
      minDate: undefined,
      maxDate: undefined,
      gridOptions: {},
      detailGridOptions: {}
    };
  },

  watch: {
    "$i18n.locale"() {
      this.setHeaders();
    },
    date() {
      this.dateFormatted = moment(this.date).format("YYYY.MM.DD");
      this.mapDate = moment(this.date).toDate();
      this.refresh();
    },
    config(config) {
      if (config) {
        this.statuses = config.statuses;
        this.setHeaders();
      }
    },
    search() {
      this.gridOptions.page = 1;
    },
    detailSearch() {
      this.detailGridOptions.page = 1;
    }
  },

  mounted() {
    if (this.config) {
      this.statuses = this.config.statuses;
    }

    const datesResult = getDates();

    this.minDate = datesResult.minDate;
    this.maxDate = datesResult.maxDate;

    this.setHeaders();
    this.date = this.mapDate.toISOString();
  },

  computed: {
    ...mapState({
      config: state => state.app.config
    }),
    byPrimaryAddress: {
      get() {
        return this.$store.state.map.filterByPrimaryAddress;
      },
      set(value) {
        this.$store.commit("map/setFilterByPrimaryAddress", value);
        this.refresh();
      }
    },
    mapDate: {
      get() {
        return this.$store.state.map.date;
      },
      set(value) {
        this.$store.commit("map/setDate", value);
      }
    }
  },

  methods: {
    async refresh() {
      this.items = [];
      const { data } = await api.getAreaStats({
        date: moment(this.date).toISOString(),
        byPrimaryAddress: this.byPrimaryAddress
      });

      if (data && data.features && data.features.length) {
        data.features.forEach(element => {
          this.items.push(element.properties);
        });
      }
    },
    async expanded(result) {
      this.detailSearch = "";
      this.detailItems = [];

      if (result.value) {
        const { data } = await api.getAreaStats({
          date: this.date,
          county: result.item.place,
          byPrimaryAddress: this.byPrimaryAddress
        });
        if (data && data.features && data.features.length) {
          data.features.forEach(element => {
            this.detailItems.push(element.properties);
          });
        }
        this.expandedArray = [result.item];
      } else {
        this.expandedArray = [];
      }
    },
    setHeaders: function () {
      (this.headers = [
        {
          text: this.$t("County"),
          align: "start",
          value: "place"
        },
        ...translateLabel(this.statuses).filter(a => a.showOnMap),
        { text: "", value: "actions", width: "80", sortable: false }
      ]),
        (this.detailHeaders = [
          {
            text: this.$t("Settlement"),
            align: "start",
            value: "place"
          },
          ...translateLabel(this.statuses).filter(a => a.showOnMap),
          { text: "", value: "actions", width: "80", sortable: false }
        ]);
    },
    async exportData() {
      const { data } = await api.getAreaStatsXlsx({
        date: moment(this.date).toISOString(),
        byPrimaryAddress: this.byPrimaryAddress
      });
      let a = document.createElement('a');
      a.href = window.URL.createObjectURL(new Blob([data]));
      a.download = 'export_' + moment(this.date).format('YYYY-MM-DD') + '.xlsx';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }
};
</script>
